import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-216f6bca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "module case" }
const _hoisted_2 = { class: "module-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "module-title" }, "成功案例", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "module-subTitle" }, "服务至今，爱乐云已成功帮助全国多个婚恋品牌实现转型及盈利", -1))
const _hoisted_5 = { class: "case-list" }
const _hoisted_6 = { class: "case-item" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "case-footer" }
const _hoisted_9 = { class: "case-brand" }
const _hoisted_10 = {
  key: 0,
  class: "case-shop"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "case-tip" }, "详情及更多案例可咨询顾问获取哦！", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cases, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "case-itemBox"
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                class: "case-logo",
                src: require(`@/assets/images/case/${item.logo}.png`)
              }, null, 8, _hoisted_7),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, _toDisplayString(item.brand), 1),
                (item.shop)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(item.shop), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        }), 128))
      ]),
      _hoisted_11,
      _createElementVNode("div", {
        class: "case-btn",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.consult && _ctx.consult(...args)))
      }, "咨询更多")
    ])
  ]))
}